import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '../store';

import AdminLayout from '../components/Admin/Layout/AdminLayout.vue';
import OuterLayout from '../components/Admin/Layout/OuterLayout.vue';

import Destinations from '../components/Admin/Views/Destinations.vue';
import DestinationForm from '../components/Admin/Views/DestinationForm.vue';
import Callback from '../components/Admin/Views/Callback.vue';
import Forgot from '../components/Admin/Views/Forgot.vue';
import Links from '../components/Admin/Views/Links.vue';
import LinkForm from '../components/Admin/Views/LinkForm.vue';
import Login from '../components/Admin/Views/Login.vue';
import ChangeTempPassword from '../components/Admin/Views/ChangeTempPassword.vue';
import ResetPassword from '../components/Admin/Views/ResetPassword.vue';
import Sessions from '../components/Admin/Views/Sessions.vue';
import Users from '../components/Admin/Views/Users.vue';
import UserForm from '../components/Admin/Views/UserForm.vue';
import NotFound from '../components/NotFound.vue';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    linkActiveClass: 'nav-item active',
    routes: [
        {
            path: '/',
            component: AdminLayout,
            redirect: '/admin/destinations',
            meta: {
                auth: true
            },
        },
        {
            path: '/callback',
            name: 'callback',
            component: Callback,
            meta: {
                auth: false
            },
        },

        {
            path: '/auth',
            component: OuterLayout,
            redirect: '/auth/login',
            children: [
                {
                    path: '/auth/login',
                    name: 'login',
                    component: Login,
                    meta: {
                        auth: false
                    },
                },
                {
                    path: '/auth/change',
                    name: 'changeTempPassword',
                    component: ChangeTempPassword,
                    meta: {
                        auth: false
                    },
                },
                {
                    path: '/auth/forgot',
                    name: 'forgotPassword',
                    component: Forgot,
                    meta: {
                        auth: false
                    },
                },
                {
                    path: '/auth/reset',
                    name: 'resetPassword',
                    component: ResetPassword,
                    meta: {
                        auth: false
                    },
                },
            ]
        },

        // {
        //     path: '/error',
        //     name: 'error',
        //     component: ErrorMsg,
        //     props: true,
        //     meta: {
        //         auth: false
        //     },
        // },
        {
            path: '/admin',
            component: AdminLayout,
            redirect: '/admin/destinations',
            children: [
                {
                    path: '/admin/sessions/:did',
                    name: 'sessions',
                    component: Sessions,
                    props: true,
                    meta: {
                        auth: true
                    },
                },
                {
                    path: '/admin/destinations',
                    name: 'destinations',
                    component: Destinations,
                    props: true,
                    meta: {
                        auth: true
                    },
                },
                {
                    path: '/admin/destinations/:did',
                    name: 'destination',
                    component: DestinationForm,
                    props: true,
                    meta: {
                        auth: true
                    },
                },
                {
                    path: '/admin/links/:did',
                    name: 'links',
                    component: Links,
                    props: true,
                    meta: {
                        auth: true
                    },
                },
                {
                    path: '/admin/links/:did/create',
                    name: 'linkform',
                    component: LinkForm,
                    props: true,
                    meta: {
                        auth: true
                    },
                },
                {
                    path: '/admin/users/:did',
                    name: 'users',
                    component: Users,
                    props: true,
                    meta: {
                        auth: true
                    },
                },
                {
                    path: '/admin/users/:did/create',
                    name: 'userform',
                    component: UserForm,
                    props: true,
                    meta: {
                        auth: true
                    },
                },
            ]
        },
        {
            path: '*',
            component: NotFound
        }
    ],
});

// no routing until user init
let routerInit: boolean = false;
router.beforeEach(async (to, from, next) => {
    if (!!!routerInit) {
        routerInit = true;
        try {
            await store.dispatch('$auth/restore');
        } catch (e) {
            console.log(e);
        }
    }

    // Use the page's router title to name the page
    if (to.meta && to.meta.title) {
        document.title = to.meta.title
    }

  // Redirect to the login page if not authenticated
  // for pages that have 'auth: true' set
  if (to.meta && to.meta.auth !== undefined) {
    if (to.meta.auth) {
      if (store.getters['$auth/isAuthenticated']) {
        next();
      } else {
        router.push({ name: 'login' })
      }
    } else {
      if (store.getters['$auth/isAuthenticated']) {
        router.push({ name: 'destinations' })
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

export default router;